export default "__VITE_ASSET__16b89bc9__"